import { useMemo } from 'react';

export const useEnrichedLinks = ({ links, categories }) => {
  // Generate map of category/subcategory IDs to titles, i.e.
  // {
  //   [categoryId: string]: string
  // }
  const categoryTitles = useMemo(() => {
    if (!categories) return;
    const result = {};
    categories.forEach((category) => {
      const { id, subcategories, title } = category;
      result[id] = title;

      if (subcategories?.length) {
        subcategories.forEach((subcat) => {
          const { id, title } = subcat;
          result[id] = title;
        });
      }
    });
    return result;
  }, [categories]);

  // Enrich each link with category/subcategory titles
  const enrichedLinks = useMemo(() => {
    if (!links.length || !categoryTitles) return [];

    return links.map((link) => {
      const { categories } = link;

      const enrichedCategories =
        categories?.map((category) => {
          const { id, subcategories } = category;

          const enrichedSubcategories =
            subcategories?.map((subcat) => {
              return {
                ...subcat,
                title: categoryTitles[subcat.id],
              };
            }) ?? [];

          return {
            ...category,
            title: categoryTitles[id],
            subcategories: enrichedSubcategories,
          };
        }) ?? [];

      const enrichedLink = { ...link, categories: enrichedCategories };
      return enrichedLink;
    });
  }, [links, categoryTitles]);

  return enrichedLinks;
};
